module.exports = __webpack_public_path__ + "static/img/yst_header_bg.73cb1029.png";